import cn from "classnames";
import BidsFilter from "components/bids/filter";
import * as configs from "components/bids/filter/config";
import Select, { customFilterSelectStyles } from "components/shared/select";
import React from "react";

export default class DistributionBidsFilter extends BidsFilter {
    UNSAFE_componentWillMount() {
        return undefined;
    }

    get tags() {
        const { roles, showFullAddress } = this.props;
        const isSelected = (name) => this.filterValue(name);
        return [
            {
                name: "Наемный ТС",
                selected: isSelected("hasHiredCar"),
                show: true,
                onChange: this.mergeFilters.bind(this, { name: "hasHiredCar", value: !isSelected("hasHiredCar") }),
            },
            {
                name: "Обязательный заказ",
                selected: isSelected("isMandatory"),
                show: true,
                onChange: this.mergeFilters.bind(this, { name: "isMandatory", value: !isSelected("isMandatory") }),
            },
            {
                name: "Внешний заказ",
                selected: isSelected("isExternalDistributionBid"),
                show: true,
                onChange: this.mergeFilters.bind(this, {
                    name: "isExternalDistributionBid",
                    value: !isSelected("isExternalDistributionBid"),
                }),
            },
            {
                name: "ЭЗЗ",
                selected: isSelected("isShippingOrder"),
                show: true,
                onChange: this.mergeFilters.bind(this, {
                    name: "isShippingOrder",
                    value: !isSelected("isShippingOrder"),
                }),
            },
            {
                name: "Удалённые",
                selected: isSelected("isDeleted"),
                show: roles.isTruckingOrganizationAdmin || roles.isRoot,
                onChange: this.mergeFilters.bind(this, { name: "isDeleted", value: !isSelected("isDeleted") }),
            },
            {
                name: "Показывать полный адрес",
                selected: showFullAddress,
                show: true,
                onChange: this.props.toggleFullAddress,
            },
            {
                name: "Отображать стоимость с учётом затрат",
                selected: isSelected("showCostAwareValues"),
                show: true,
                onChange: this.mergeFilters.bind(this, {
                    name: "showCostAwareValues",
                    value: !isSelected("showCostAwareValues"),
                }),
            },
            {
                name: "Отобразить адреса промежуточных точек",
                selected: isSelected("showAllPointAddresses"),
                show: true,
                onChange: this.mergeFilters.bind(this, {
                    name: "showAllPointAddresses",
                    value: !isSelected("showAllPointAddresses"),
                }),
            },
            {
                name: "Отобразить организацию",
                selected: isSelected("showOrganizationColumn"),
                show: this.state.legalPersonCount >= 2,
                onChange: this.mergeFilters.bind(this, {
                    name: "showOrganizationColumn",
                    value: !isSelected("showOrganizationColumn"),
                }),
            },
            {
                name: "Предзаявка",
                selected: isSelected("isPreBid"),
                show: true,
                onChange: this.mergeFilters.bind(this, { name: "isPreBid", value: !isSelected("isPreBid") }),
            },
        ];
    }

    renderStatusSelect = () => {
        const props = {
            ...configs.distributionBidsStatusConfig,
            onChange: this.mergeFilters,
            value: this.filterValue("distributionBidsStatus"),
            styles: { ...customFilterSelectStyles },
        };
        return (
            <div className="b-filter__body-cell">
                <Select {...this.selectProps} {...props} />
            </div>
        );
    };

    renderLegalPersonSelect = () => {
        const props = {
            ...configs.legalPersonConfig,
            onChange: this.mergeFilters,
            value: this.filterValue("legalPersonId"),
            styles: { ...customFilterSelectStyles },
        };
        return (
            <div className="b-filter__body-cell">
                <Select {...props} />
            </div>
        );
    };

    renderCreatorSelect = () => {
        const props = {
            ...configs.distributionBidCreatorConfig,
            onChange: this.mergeFilters,
            value: this.filterValue("createdById"),
            styles: { ...customFilterSelectStyles },
        };
        return (
            <div className="b-filter__body-cell">
                <Select {...props} />
            </div>
        );
    };

    renderResponsibleSelect = () => {
        const props = {
            ...configs.responsibleConfig,
            onChange: this.mergeFilters,
            value: this.filterValue("responsibleId"),
            styles: { ...customFilterSelectStyles },
        };
        return (
            <div className="b-filter__body-cell">
                <Select {...props} />
            </div>
        );
    };

    renderHiredCarCounterpartySelect = () => {
        const props = {
            ...configs.hiredCarCounterpartyConfig,
            onChange: this.mergeFilters,
            value: this.filterValue("hiredCarCounterpartyId"),
            styles: { ...customFilterSelectStyles },
        };
        return (
            <div className="b-filter__body-cell">
                <Select {...props} />
            </div>
        );
    };

    renderTrailerTypeSelect = () => {
        const props = {
            ...configs.trailerConfig,
            onChange: this.mergeFilters,
            value: this.filterValue("trailerTypeId"),
            options: this.props.enums.trailerType,
            styles: { ...customFilterSelectStyles },
        };
        return (
            <div className="b-filter__body-cell">
                <Select {...this.selectProps} {...props} />
            </div>
        );
    };

    render() {
        const {
            filters: { isDeleted, ...filters },
            filtersOpened,
            toggleFilter,
        } = this.props;
        const cname = cn("b-filter__body-double-cell--inputs", {
            "b-filter__body-double-cell--inputs-with-button": this.filterValue("from") && this.filterValue("to"),
        });
        const expandCname = cn("b-filter__collapse-btn", {
            "b-filter__collapse-btn--top": filtersOpened,
            "b-filter__collapse-btn--bottom": !filtersOpened,
        });
        const headerTextCname = cn("b-filter__search-text", {
            "b-filter__search-text--dark": filtersOpened,
        });
        return (
            <div className="b-filter">
                <div className="b-filter__head" onClick={toggleFilter}>
                    <div className="b-filter__head--left">
                        {!filtersOpened && <div className="b-filter__search-icon" />}
                        <div className={headerTextCname}>Найти заказ</div>
                    </div>
                    <div className="b-filter__head--right">
                        {!filtersOpened && (
                            <>
                                {(Object.keys(filters).length !== 0 ||
                                    (this.props.roles.isTruckingOrganizationAdmin && isDeleted)) && (
                                    <div className="b-filter__btn b-filter__btn--reset" onClick={this.resetFilters}>
                                        Сбросить
                                    </div>
                                )}
                                <div className="b-filter__btn b-filter__btn--refresh" onClick={this.refreshData}>
                                    Обновить
                                </div>
                            </>
                        )}
                        <div className={expandCname} />
                    </div>
                </div>
                {filtersOpened && (
                    <>
                        <div className="b-filter__body">
                            <div className="b-filter__body-column">
                                <div className="b-filter__body-double-cell">
                                    <div className={cname}>
                                        {this.renderPointSelect("from")}
                                        {this.renderPointSelect("to")}
                                    </div>
                                    {this.filterValue("from") && this.filterValue("to") && (
                                        <div className="b-filter__body-double-cell--button-wrap">
                                            <div
                                                className="b-filter__body-double-cell--button"
                                                onClick={this.swapPoints}
                                            />
                                        </div>
                                    )}
                                </div>
                                {this.renderIdInput()}
                                {this.renderStatusSelect()}
                                {this.renderTrailerTypeSelect()}
                                {this.renderNdsTypeSelect()}
                            </div>
                            <div className="b-filter__body-column">
                                {this.renderLoadDateInput()}
                                {this.renderUnloadDateInput()}
                                {this.renderSyncStatusSelect()}
                                {this.renderCreatorSelect()}
                                {this.renderResponsibleSelect()}
                                {this.state.legalPersonCount >= 2 && this.renderLegalPersonSelect()}
                            </div>
                            <div className="b-filter__body-column">
                                {this.renderCounterpartySelect()}
                                {this.renderCargoSenderCounterpartySelect()}
                                {this.renderCargoReceiverCounterpartySelect()}
                                {this.renderHiredCarCounterpartySelect()}
                                {this.renderContractNumberInput()}
                                {this.renderTagInputs()}
                            </div>
                        </div>
                        <div className="b-filter__footer">
                            {(Object.keys(filters).length !== 0 ||
                                (this.props.roles.isTruckingOrganizationAdmin && isDeleted)) && (
                                <div className="b-filter__btn b-filter__btn--reset" onClick={this.resetFilters}>
                                    Сбросить
                                </div>
                            )}
                            <div className="b-filter__btn b-filter__btn--refresh" onClick={this.refreshData}>
                                Обновить
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}
